<p-dialog
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
    (onHide)="onHide()"
    (onShow)="onShow()"
>
    <ng-template #header>
        {{ "scannerDialog.title" | translate }}
    </ng-template>

    <div style="width: 100%">
        <video
            id="qrVideo"
            #qrVideo
            style="width: 100%; height: 100%; object-fit: cover"
        ></video>
    </div>

    <ng-template #footer>
        <input
            class="m-btn m-btn-primary"
            (click)="cancel()"
            type="button"
            value="{{ 'form.cancel' | translate }}"
        />
    </ng-template>
</p-dialog>
